import { publicConfig } from "@/configs/public-config";
import { getFilenameFromContentDisposition as getFilenameFromContentDispositionShared } from "@/shared/helpers/api-file-download.helper";

import {
  fetchAuthenticatedReportExport,
  fetchAuthenticatedReportExportPost,
  getExportFilenameFallback as buildExportFilenameFallback,
  type IFetchReportExportResult,
} from "./report-export.helpers";
import {
  ReportExportFormat,
  type IExportReportArg,
  type IExportCustomReportArg,
  type IExportStudentListReportRequest,
} from "./reports.interface";

export type { IFetchReportExportResult };

export function getExportFilenameFallback(format: ReportExportFormat): string {
  return buildExportFilenameFallback(format);
}

export function getExportFilenameFromContentDisposition(
  contentDisposition: string | null,
  format: ReportExportFormat,
): string {
  return getFilenameFromContentDispositionShared(
    contentDisposition,
    buildExportFilenameFallback(format),
  );
}

export async function fetchReportExport(arg: IExportReportArg): Promise<IFetchReportExportResult> {
  const { reportId, format } = arg;
  const baseUrl = `${publicConfig.apiUrl}/${publicConfig.apiTag}`;
  const url = `${baseUrl}/report/saved/${reportId}/export?format=${format}`;

  return fetchAuthenticatedReportExport(url, format, getExportFilenameFromContentDisposition);
}

export async function fetchCustomReportExport(
  arg: IExportCustomReportArg,
): Promise<IFetchReportExportResult> {
  const { customReportId, format, districtId } = arg;
  const baseUrl = `${publicConfig.apiUrl}/${publicConfig.apiTag}`;
  const params = new URLSearchParams({ format });
  if (districtId != null && districtId !== "") {
    params.set("districtId", districtId);
  }
  const url = `${baseUrl}/report/custom/${customReportId}/export?${params.toString()}`;

  return fetchAuthenticatedReportExport(url, format, getExportFilenameFromContentDisposition);
}

export async function fetchAiReportExport(reportId: string): Promise<IFetchReportExportResult> {
  const baseUrl = `${publicConfig.apiUrl}/${publicConfig.apiTag}`;
  const url = `${baseUrl}/report/ai/${reportId}/export`;

  return fetchAuthenticatedReportExport(
    url,
    ReportExportFormat.CSV,
    getExportFilenameFromContentDisposition,
  );
}

export async function fetchStudentListReportExport(
  arg: IExportStudentListReportRequest,
): Promise<IFetchReportExportResult> {
  const baseUrl = `${publicConfig.apiUrl}/${publicConfig.apiTag}`;
  const url = `${baseUrl}/report/student-list/export`;

  return fetchAuthenticatedReportExportPost(
    url,
    arg.format,
    arg,
    getExportFilenameFromContentDisposition,
  );
}
